import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { CardHistoryChDto, PointsHistoryChDto } from '../../cheetah/client/dto/models';
import type { AllGiftCardOfferCouponDto } from '../../dto-common-website/fidelity-card/models';
import type { SearchHistoryDto } from '../../dto-common-website/models';

@Injectable({
  providedIn: 'root',
})
export class FidelityCardService {
  apiName = 'Default';
  

  disabledCard = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: '/api/app/fidelity-card/disabled-card',
    },
    { apiName: this.apiName,...config });
  

  getAllOfferCard = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, AllGiftCardOfferCouponDto>({
      method: 'GET',
      url: '/api/app/fidelity-card/offer-card',
    },
    { apiName: this.apiName,...config });
  

  getCardHistory = (searchHistory: SearchHistoryDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<CardHistoryChDto>>({
      method: 'GET',
      url: '/api/app/fidelity-card/card-history',
      params: { customerId: searchHistory.customerId, pageNumber: searchHistory.pageNumber, resultPerPage: searchHistory.resultPerPage, ean: searchHistory.ean, periodStart: searchHistory.periodStart, periodEnd: searchHistory.periodEnd },
    },
    { apiName: this.apiName,...config });
  

  getPointsHistory = (searchPointsHistory: SearchHistoryDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<PointsHistoryChDto>>({
      method: 'GET',
      url: '/api/app/fidelity-card/points-history',
      params: { customerId: searchPointsHistory.customerId, pageNumber: searchPointsHistory.pageNumber, resultPerPage: searchPointsHistory.resultPerPage, ean: searchPointsHistory.ean, periodStart: searchPointsHistory.periodStart, periodEnd: searchPointsHistory.periodEnd },
    },
    { apiName: this.apiName,...config });
  

  reactivatedCard = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: '/api/app/fidelity-card/reactivated-card',
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
